import "./logConfig";
import "./Features";
import { LogStore } from "Feature/Logging/LogStore";
import { addLoggingFeature, ECSLogger, LogAction, serviceProvider } from "@zebrasoft/core-ui";
import { UrlProvider } from "Library/UrlProvider";



const apiKeys = {
    "local": "logkey_01h6v1gfcxfkctm5g8wz2hz493",
    "test": "logkey_01h6v1j62zebeb350pt0dxfqyh",
    "production": "logkey_01h6v1jb17f06tkm9r1dxch1zs"
}

addLoggingFeature({
    apiKey: apiKeys[UrlProvider.environment],
});



document.addEventListener("DOMContentLoaded", () => {
    const logger = serviceProvider.resolve<ECSLogger>(ECSLogger);
    console.log("Zebra Escapes Website Loaded");
    logger.logAction(LogAction.PageHit, "Zebra Escapes Website");
});